import {
  IRecurringBookingRequest,
  IRecurringBookingSubset,
} from 'external-services/recurring-booking-service/type';

export interface IRecurringBookingState {
  isRecurringBookingSaved: boolean;
  openRepeatBookingTab: boolean;
  isClickedLoad?: boolean;
  bookingList: IRecurringBookingSubset[];
  requestParameters: IRecurringBookingRequest;  
  recurringBookingList: IRecurringBookingSubset[];
  recurringBookingConfirmationStatus: RecurringBookingConfirmStatus;
}

export enum RecurringBookingConfirmStatus {
  NotStartConfirming = 'not_start_confirming',
  WaitingForConfirmation = 'waiting_for_confirmation',
  Confirmed = 'confirmed'
}
